import React from "react";
import ReactMarkdown from "react-markdown";

/**
 * MarkdownPreview
 * @param {string} content - markdown本文
 * @param {number|null} maxLength - 文字数制限（null で無制限）
 */
const MarkdownPreview = ({ content = "", maxLength = null }) => {
  if (!content) return null;

  // --- 文字数制限 ---
  const displayText =
    typeof maxLength === "number" && content.length > maxLength
      ? content.slice(0, maxLength) + "…"
      : content;

  return <ReactMarkdown>{displayText}</ReactMarkdown>;
};

export default MarkdownPreview;
